import { SelectOption } from 'global';
import { SendOcaLinkSendMethods } from '@trnsact/trnsact-shared-types';

import { SendApplicationFormTemplates, SendApplicationFormValues } from './types';

export const sendMethodOptions: SelectOption<SendOcaLinkSendMethods>[] = [
  { label: 'Email', value: SendOcaLinkSendMethods.Email },
  { label: 'Text', value: SendOcaLinkSendMethods.Text },
  { label: 'Email and Text', value: SendOcaLinkSendMethods.TextAndEmail },
];

export const creditAppTemplateOptions: SelectOption<SendApplicationFormTemplates>[] = [
  { label: 'Dealer Credit Application Template', value: SendApplicationFormTemplates.Personal },
  { label: 'Lender Credit Application Template', value: SendApplicationFormTemplates.Lender },
];

export const enum TestIds {
  EmailInput = 'EmailInput',
  MobilePhoneInput = 'MobilePhoneInput',
  SendViaRadioGroup = 'SendViaRadioGroup',
  TemplateRadioGroup = 'TemplateRadioGroup',
  LenderCreditAppTemplate = 'LenderCreditAppTemplate',
}

export const sendApplicationFormInitialValues: SendApplicationFormValues = {
  lenderProfileId: '',
  listOfInventory: [],
  isPromoteFlyer: false,
  sendMethod: SendOcaLinkSendMethods.TextAndEmail,
  creditApplicationTemplate: SendApplicationFormTemplates.Personal,
  finance: {
    term: '',
    rate: 0,
    downPayment: 0,
  },
  contactDetails: {
    email: '',
    lastName: '',
    firstName: '',
    mobilePhone: '',
    businessName: '',
  },
  equipment: {
    year: '',
    make: '',
    model: '',
    mileage: 0,
    quantity: 1,
    serialVin: '',
    condition: '',
    description: '',
    stockNumber: '',
    amountRequested: 0,
  },
};
